import { Alert, Title } from "@mantine/core";

import { AppLayout } from "@/components/AppLayout";
import { t } from "@/i18n";

/**
 * Shown when a caller holding the portal permission signs in without an
 * `organization_unit_id` claim.
 *
 * ADR-0022 makes the claim REQUIRED for the role, so this is a token
 * misconfiguration, not an empty tenant. Both alternatives are worse than
 * stopping: rendering an empty portal reads as "you have no users", and any
 * default org would be someone else's data. The portal refuses to guess.
 */
export function TenantMisconfiguredPage(): JSX.Element {
  return (
    <AppLayout breadcrumbs={[{ label: t("portal.title") }]}>
      <Title order={1}>{t("portal.misconfigured_title")}</Title>
      <Alert color="red" mt="md">
        {t("portal.misconfigured_body")}
      </Alert>
    </AppLayout>
  );
}
